"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCustomConnector = exports.isTrayConnector = exports.CUSTOM_CONNECTOR_TYPES = exports.TRAY_CONNECTOR_TYPES = exports.ConnectorType = void 0;
var ConnectorType;
(function (ConnectorType) {
    ConnectorType["CsvToDynamo"] = "CsvToDynamo";
    ConnectorType["Salesforce"] = "Salesforce";
    ConnectorType["WebServiceApi"] = "WebServiceApi";
    ConnectorType["QueryParams"] = "QueryParams";
    ConnectorType["SystemElement"] = "SystemElement";
    ConnectorType["Custom"] = "Custom";
    ConnectorType["CustomLambda"] = "CustomLambda";
    ConnectorType["TraySalesforce"] = "TraySalesforce";
    ConnectorType["TrayHubspot"] = "TrayHubspot";
    ConnectorType["TrayGoogleSheets"] = "TrayGoogleSheets";
    ConnectorType["TrayMarketo"] = "TrayMarketo";
    //TraySnowflake = "TraySnowflake",
    ConnectorType["Dummy"] = "Dummy";
})(ConnectorType = exports.ConnectorType || (exports.ConnectorType = {}));
exports.TRAY_CONNECTOR_TYPES = [
    ConnectorType.TraySalesforce,
    ConnectorType.TrayHubspot,
    ConnectorType.TrayGoogleSheets,
    ConnectorType.TrayMarketo
    //ConnectorType.TraySnowflake
];
exports.CUSTOM_CONNECTOR_TYPES = [
    ConnectorType.Custom,
    ConnectorType.CustomLambda
];
const isTrayConnector = (connectorType) => {
    return exports.TRAY_CONNECTOR_TYPES.includes(connectorType);
};
exports.isTrayConnector = isTrayConnector;
const isCustomConnector = (connectorType) => {
    return exports.CUSTOM_CONNECTOR_TYPES.includes(connectorType);
};
exports.isCustomConnector = isCustomConnector;
//# sourceMappingURL=connectors.js.map